export default __webpack_public_path__ + "static/media/ltc_whitepaper.ae0dda13.gif";